// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SnsFacebook from '../_raw/ui/icon_sns_facebook.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SnsFacebook);
